<template>
	<!-- 现货订单 -->
	<div class="rootDiv">
		<div class="retrieve">
			<div class="searchDiv flex flex-jb">
				<div>
					<el-button type="primary" @click="ShowSearchClick">检索</el-button>
				</div>
				<div>
					<el-input @keydown.enter.native="submitSearch" @clear="submitSearch" clearable class="w-450"
						placeholder="请输入套数编码、系列名称、商品名称" v-model="retrieveForm.conditions">
						<el-button slot="append" type="primary" icon="el-icon-search" @click="submitSearch"></el-button>
					</el-input>
				</div>
				<div class="flex flex-ac">
					<div class="ml-40 fc-6b9eff fs-16 pointer" @click="exportExcel">
						<i class="el-icon-upload mr-10 fs-18"></i>导出
					</div>
				</div>
			</div>
		</div>
		<!-- 撤销弹窗 -->
		<el-dialog title="商品信息" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<el-table ref="multipleTable" :data="shujuList" tooltip-effect="dark" style="width: 100%"
				:header-cell-style="{background:'#ecf5ff'}" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" width="55" lable='序号'>
				</el-table-column>
				<!-- <el-table-column label="发货单号" width="120" prop="sendNo">
			</el-table-column> -->
				<el-table-column label="头像">
					<template slot-scope="scope">
						<img :src="scope.row.userImg" width="40" height="40" />
					</template>
				</el-table-column>
				<el-table-column prop="userName" label="用户名" width="100" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="商品信息" width="100">
					<template slot-scope="scope">
						<div>{{scope.row.seriesName}}---{{scope.row.detailsName}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="recManAddr" label="收货地址" width="120">
			</el-table-column>
			<el-table-column prop="address" label="收货人" show-overflow-tooltip>
			</el-table-column> -->
				<el-table-column prop="outTradeNo" label="商品单号" show-overflow-tooltip width="200">
				</el-table-column>
				<el-table-column prop="price" label="价格" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="createDate" label="提交时间" show-overflow-tooltip width="200">
				</el-table-column>
				<!-- <el-table-column fixed="right" label="操作" width="120">
				<template slot-scope="scope">
					<el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
						移除
					</el-button>
				</template>
			</el-table-column> -->
			</el-table>
			<div class="button">
				<!-- <el-button type="primary" @click="chehuiSold(1)" plain class="button1">撤回预售</el-button> -->
				<el-button type="primary" @click="chehuiSold(2)" plain class="button1">撤回现货</el-button>
				<el-button type="primary" @click="chehuiSold(3)" plain class="button1">撤回待发货</el-button>
			</div>
			<!-- <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		</span> -->
		</el-dialog>
		<!-- 删除弹窗 -->
		<el-dialog title="删除" :visible.sync="delectVisible" width="50%" :before-close="handleClose">
			<el-table ref="multipleTable" :data="shujuList" tooltip-effect="dark" style="width: 100%"
				:header-cell-style="{background:'#ecf5ff'}" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" width="55" lable='序号'>
				</el-table-column>
				<!-- <el-table-column label="发货单号" width="120" prop="sendNo">
			</el-table-column> -->
				<el-table-column label="头像">
					<template slot-scope="scope">
						<img :src="scope.row.userImg" width="40" height="40" />
					</template>
				</el-table-column>
				<el-table-column prop="userName" label="用户名" width="100" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="商品信息" width="100">
					<template slot-scope="scope">
						<div>{{scope.row.seriesName}}---{{scope.row.detailsName}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="recManAddr" label="收货地址" width="120">
			</el-table-column>
			<el-table-column prop="address" label="收货人" show-overflow-tooltip>
			</el-table-column> -->
				<el-table-column prop="outTradeNo" label="商品单号" show-overflow-tooltip width="200">
				</el-table-column>
				<el-table-column prop="price" label="价格" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="createDate" label="提交时间" show-overflow-tooltip width="200">
				</el-table-column>
				<!-- <el-table-column fixed="right" label="操作" width="120">
				<template slot-scope="scope">
					<el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
						移除
					</el-button>
				</template>
			</el-table-column> -->
			</el-table>
			<div class="button">
				<el-button type="primary" @click="delectClick" plain class="button1">删除</el-button>
			</div>
			<!-- <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		</span> -->
		</el-dialog>
		<el-dialog :visible.sync="isShowSearch" title="检索列表" size="80%" :with-header="false">
			<div class="retrieveDiv flex flex-ac flex-w">
				<div class="search-width mr-30 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">收货人：</span>
					<el-input class="w-250" v-model="retrieveForm.recManName" clearable></el-input>
				</div>
				<div class="search-width mr-30 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">收货人手机号：</span>
					<el-input class="w-250" v-model="retrieveForm.recManPhone" clearable></el-input>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1  mr-20">发货单号：</span>
					<el-input class="w-250" v-model="retrieveForm.sendNo" clearable></el-input>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">商户号：</span>
					<el-input class="w-250" v-model="retrieveForm.mchId" clearable></el-input>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1  mr-20">商户单号：</span>
					<el-input class="w-250" v-model="retrieveForm.outTradeNo" clearable></el-input>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">用户名：</span>
					<el-input class="w-250" v-model="retrieveForm.userName" clearable></el-input>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">手机号：</span>
					<el-input class="w-250" v-model="retrieveForm.phone" clearable></el-input>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">人员类型：</span>
					<el-select class="w-150" v-model="retrieveForm.isTest" clearable placeholder="请选择">
						<el-option label="正式人员" :value="0">
						</el-option>
						<el-option label="测试人员" :value="1">
						</el-option>
					</el-select>
				</div>
				<div class="search-width mr-30 mt-20 flex flex-ac">
					<span class="width-100 fs-16 flex1 mr-20">发货时间：</span>
					<el-date-picker class="w-250" v-model="startEndDate" type="daterange" valueFormat="yyyy-MM-dd"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handPickerChange">
					</el-date-picker>
				</div>
				<div class="search-width mt-20">
				</div>
				<div class="mt-20 flex-1" style="text-align: right;">
					<el-button type="primary" @click="submitSearch">查询</el-button>
				</div>
			</div>
		</el-dialog>
		<TableHeightFull class="tableDiv pall-10">
			<!-- 表格 -->
			<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
				stripe @row-click="headerRowClick" v-loading="tabLoading" :row-style="{ cursor: 'pointer' }">
				<template v-slot:img="scope">
					<img :src="scope.row.userImg" alt="" class="smallImg">
				</template>
				<template v-slot:detailsList="scope">
					<div v-for="(item,index) in scope.row.list" :key="item.id">
						<div class="flex flex-ac">
							<div>{{item.seriesName?item.seriesName:formatGoodType(item.goodsType)}}</div>
							<div>{{item.detailsName}} </div>- <img :src="item.detailsImg" alt="" class="smallImg">- <div>
								{{item.price}}
							</div>
						</div>
						<div>商户单号：{{item.outTradeNo?item.outTradeNo:'无'}}</div>
					</div>
				</template>
			</EleTable>
			<!-- 分页 -->
			<PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableList" />
		</TableHeightFull>
		<!-- 打印模板 -->
		<vue-easy-print tableShow ref="easyPrint" v-show="false">
			<template slot-scope="func">
				<print-template :printInnerHTML="printInnerHTML"></print-template>
			</template>
		</vue-easy-print>
		<!-- 发货记录 -->
		<el-dialog title="发货记录" :visible.sync="recordVisible" width="50%" :before-close="handleClose">
			<el-table ref="multipleTable" :data="shujuList" tooltip-effect="dark" style="width: 100%"
				:header-cell-style="{background:'#ecf5ff'}">
				<el-table-column prop="partSendNo" label="发货单号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="sendNo" label="拆分单号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="createDate" label="创建时间" show-overflow-tooltip>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	import indexMixin from "@/utils/indexMixin"
	import printTemplate from "@/components/printTemplate.vue"
	import vueEasyPrint from "vue-easy-print"
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'drawsGood',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
			"CountDown": (resolve) => require(["@/components/CountDown"], resolve),
			printTemplate,
			vueEasyPrint
		},
		computed: {
			...mapState('menu', {
				'goodsTypes': state => state.dictList ? state.dictList.goods_type : [], //商品类型
			})
		},
		data() {
			return {
				dialogVisible: false, //控制撤销弹窗
				delectVisible: false, //控制删除弹窗
				recordVisible:false,
				printInnerHTML: '', //打印链接
				retrieveForm: {
					conditions: '', //整合条件
					// detailsName: '', //商品名称,模糊匹配
					// pageNo: '', //套数编码
					// seriesName: '', //系列名称,模糊匹配
					sendNo: '', //订单号
					mchId:'',
					outTradeNo: '', //商户订单号
					userName: '', //用户名称 模糊匹配
					tradingType: 4, //商品状态
					phone: '', //用户手机号,模糊匹配
					isTest: 0, //是否测试
					startDate: '', //开始时间
					endDate: '', //	结束时间
				},
				startEndDate: [], //时间区间
				tabLoading: false,
				butLoading: false,
				columns: [{
					type: 'index',
					label: '序号',
					width: '60',
					align: 'center',
					fixed: 'left',
					index: this.indexMethod
				}, {
					label: '发货单号',
					prop: 'sendNo',
					align: 'left',
					width: '170'
				}, {
					columnType: 'custom',
					label: '头像',
					prop: 'img',
					align: 'left',
					width: '80'
				}, {
					label: '用户名',
					prop: 'userName',
					align: 'left',
					width: '100'
				}, {
					label: '快递单号',
					prop: 'expressageNo',
					align: 'left',
					width: '140',
				}, {
					label: '收货地址',
					prop: 'recManAddr',
					align: 'left',
					width: '200',
				}, {
					label: '收货人',
					prop: 'recManName',
					align: 'left',
					width: '80',
					'show-overflow-tooltip': true
				}, {
					label: '收货手机号',
					prop: 'recManPhone',
					align: 'left',
					width: '120'
				}, {
					columnType: 'fun',
					label: '商品数量',
					prop: 'list',
					align: 'left',
					width: '80',
					formatData: (e) => {
						return e.length
					}
				}, {
					columnType: 'custom',
					label: '商品',
					prop: 'detailsList',
					align: 'left',
					width: '600'
				}, {
					label: '发货时间',
					prop: 'deliverDate',
					align: 'left',
					width: '170',
				}, {
					columnType: 'button',
					label: '操作',
					align: 'right',
					fixed: 'right',
					width: '230',
					buttons: [{
						type: 'text',
						text: '发货记录',
						fn: this.deliverRecord,
					},{
						type: 'text',
						text: '复打',
						fn: this.doublePrint,
					}, {
						type: 'text',
						text: '删除',
						fn: this.deleteList,
					}, {
						type: 'text',
						text: '取消发货',
						fn: this.recallList,
					}, ],
				}, ],
				tableData: [],
				shujuList: [],
				isShowSearch: false,
			}
		},
		mounted() {
			this.getTableList()
		},
		methods: {
			//查询
			submitSearch() {
				this.pageInfo.pageNum = 1
				this.isShowSearch = false
				this.getTableList()
			},
			//是否显示检索功能
			ShowSearchClick() {
				this.isShowSearch = !this.isShowSearch
			},
			//导出
			exportExcel() {
				this.$http.post('/tradingOrder/exceportOrder', {
					...this.retrieveForm
				}, {
					responseType: "blob", // 1.首先设置responseType对象格式为 blob:
				}).then((result) => {
					let blob = new Blob([result.data], {
						type: "application/vnd.ms-excel",
					})
					// 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
					let url = window.URL.createObjectURL(blob) // 3.创建一个临时的url指向blob对象
					// 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
					let a = document.createElement("a")
					a.href = url
					a.download = "已发货订单.xls"
					a.click()
					// 5.释放这个临时的对象url
					window.URL.revokeObjectURL(url)
				}).catch((err) => {})
			},
			//时间变化
			handPickerChange(value) {
				if (value && value.length != 0) {
					this.retrieveForm.startDate = value[0]
					this.retrieveForm.endDate = value[1]
				} else {
					this.retrieveForm.startDate = ""
					this.retrieveForm.endDate = ""
				}
			},
			//获取表格数据
			getTableList() {
				this.tabLoading = true
				this.$http.get('/tradingOrder/findDeliverOrderList', {
					params: {
						currentPage: this.pageInfo.pageNum,
						pageSize: this.pageInfo.pageSize,
						...this.retrieveForm
					}
				}).then(({
					data: result
				}) => {
					console.log("表格数据", result)
					this.tabLoading = false
					this.tableData = result.data.list
					this.pageInfo.total = result.data.total
				}).catch(err => {
					this.tabLoading = false
				})
			},
			deliverRecord(row) {
				this.$http.get('/tradingOrder/findSplitOrderSendNo', {
					params: {
						isPart: false,
						senNo: row.sendNo
					}
				}).then(({
					data: result
				}) => {
					this.shujuList = result.data
					this.recordVisible = true
				}).catch(err => {})
			},
			//撤回
			recallList(row) {
				console.log(row)
				this.dialogVisible = true
				this.shujuList = row.list
				this.sendNum = row.sendNo
			},
			//删除
			deleteList(row) {
				this.delectVisible = true
				this.shujuList = row.list
				this.sendNum = row.sendNo
			},
			// 多选
			handleSelectionChange(val) {
				if (val) {
					let idList = val.map(ele => {
						return ele.id
					})
					this.orderIds = idList.join(',')
				}
			},
			// 撤回到预售
			chehuiSold(Type) {
				this.$http.post('/tradingOrder/cancelMultipleDelivery', {
					orderIds: this.orderIds,
					sendNo: this.sendNum,
					tradingType: Type
				}).then(res => {
					this.getTableList()
					this.dialogVisible = false
				}).catch(err => {
					if (err) {
						this.$confirm('请选择数据', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
					}
				})
			},
			//删除
			delectClick() {
				this.$confirm('您确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/tradingOrder/removeTradingOrder', {
						id: this.orderIds,
					}).then(({
						data: result
					}) => {
						this.$message({
							message: '删除成功',
							type: 'success'
						})
						this.delectVisible = false
						this.getTableList()
					})
				}).catch(_ => {})
			},
			// 关闭弹窗
			handleClose(done) {
				done()
			},
			//跳转详情
			headerRowClick(row) {},
			//发货
			doublePrint(row) {
				this.$confirm('您确认打印？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/tradingOrder/repeatPrint', {
						sendNo: row.sendNo,
						type: 0, //0是取消发货1是撤销发货
						userId: row.userId
					}).then((result) => {
						if (result.data.data) {
							// window.document.body.innerHTML = result.data.data
							// window.print()
							// window.open(result.data.data)
							this.printInnerHTML = result.data.data
							setTimeout(() => {
								this.$refs.easyPrint.print()
							}, 100)
						} else {
							this.$message({
								message: '打印成功',
								type: 'success'
							})
						}
					}).catch((err) => {})
				})
			},
			//取消
			// recallList (row) {
			//   this.$confirm('您确认撤销？', '提示', {
			//     confirmButtonText: '确定',
			//     cancelButtonText: '取消',
			//     type: 'warning'
			//   }).then(_ => {
			//     this.$http.post('/tradingOrder/cancelDelivery', {
			//       sendNo: row.sendNo,
			//       type: 0,  //0是取消发货1是撤销发货
			//       userId: row.userId
			//     }).then((result) => {
			//       this.getTableList()
			//       this.$message({
			//         message: '撤销成功',
			//         type: 'success'
			//       })
			//     }).catch((err) => { })
			//   })
			// },
			//商品类型
			formatGoodType(val) {
				if (val) {
					let goodsData = this.goodsTypes.find(ele => ele.value == val)
					if (goodsData) {
						return goodsData.key
					} else {
						return ''
					}
				} else {
					return ''
				}
			},
		},
	}
</script>
<style lang="less" scoped>
	::v-deep .gray-row {
		background: #e0e0e0 !important;
	}

	.button {
		display: flex;
		justify-content: center;
		margin-top: 22px;

		.button1 {
			width: 20%;
			font-size: 0.1rem;
			font-weight: 600;
		}
	}

	.search-width {
		width: 45%;
	}

	.width-100 {
		width: 120px;
		text-align: right;
	}
</style>